module.exports = "<div class=\"modal-dialog refund-modal\" uib-modal-transclude></div>";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/modules/orders/components/refundOrder/refund-modal-popup.html
// module id = EVkX
// module chunks = 1